import md5 from 'md5'

function hashItem(name, dateCreated) {
  return md5(name + dateCreated)
}

export default class Favorites {
  constructor(favorites) {
    this.favorites = favorites
  }

  addFavorite(item) {
    const hash = hashItem(item.name, item.dateCreated)
    if(this.favorites[hash])
      return

    this.favorites[hash] = item
  }

  isFavorited(name, dateCreated) {
    const hash = hashItem(name, dateCreated)
    return (this.favorites[hash])
  }

  getFavorite(name, dateCreated) {
    const hash = hashItem(name, dateCreated)
    if(this.favorites[hash])
      return this.favorites[hash]
  }

  removeFavorite(name, dateCreated) {
    const hash = hashItem(name, dateCreated)
    if(this.favorites[hash])
      delete this.favorites[hash]
  }

  editFavorite(editedItem) {
    const hash = hashItem(editedItem.name, editedItem.dateCreated)
    if(this.favorites[hash])
      this.favorites[hash] = editedItem
  }

  toObject() {
    return { ...this.favorites }
  }
}
